import axios from '../assets/axios.wrap';
import {Stomp} from "@stomp/stompjs";

const contextPath = '/remote';

// 通知
export function getStompClient(token) {
  return Stomp.client(`ws://${window.location.host}${contextPath}/message?token=${token}`)
}
// 持续响应任务列表
export function responseDurationList(data) {
  return axios.postByFormUrl(`${contextPath}/responseDuration/list`, data);
}

export function responseDurationStop(data) {
  return axios.postByFormUrl(`${contextPath}/responseDuration/stop`, data);
}

// 登录
export function login(data) {
  return axios.postByFormUrl(`${contextPath}/login`, data, { anon: true });
}

export function logout(data) {
  return axios.postByFormUrl(`${contextPath}/logout`, data);
}

// oss
export function ossConfig(data) {
  return axios.get(`${contextPath}/oss/config`, { params: data });
}

export function ossDelete(data) {
  return axios.postByFormUrl(`${contextPath}/oss/delete`, data);
}

// 数据字典
export function dictList(data) {
  return axios.get(`${contextPath}/dict/list`, { params: data });
}
export function dictTypeList(data) {
  return axios.get(`${contextPath}/dict/type/list`, { params: data });
}

export function dictInsert(data) {
  return axios.postByFormUrl(`${contextPath}/dict/insert`, data);
}

export function dictUpdate(data) {
  return axios.postByFormUrl(`${contextPath}/dict/update`, data);
}

export function dictDelete(data) {
  return axios.postByFormUrl(`${contextPath}/dict/delete`, data);
}

// 角色
export function roleList(data) {
  return axios.get(`${contextPath}/ra/roles`, { params: data });
}

export function roleInsert(data) {
  return axios.postByFormUrl(`${contextPath}/ra/createRole`, data);
}

export function roleDelete(data) {
  return axios.postByFormUrl(`${contextPath}/ra/deleteRole`, data);
}

export function roleUpdate(data) {
  return axios.postByFormUrl(`${contextPath}/ra/renameRole`, data);
}

// 受控资源
export function authorityList(data) {
  return axios.get(`${contextPath}/ra/authorities`, { params: data });
}

export function authorityInsert(data) {
  return axios.postByFormUrl(`${contextPath}/ra/createAuthority`, data);
}

export function authorityDelete(data) {
  return axios.postByFormUrl(`${contextPath}/ra/deleteAuthority`, data);
}

export function authorityUpdate(data) {
  return axios.postByFormUrl(`${contextPath}/ra/renameAuthority`, data);
}

export function getRoleAuthorities(data) {
  return axios.get(`${contextPath}/ra/getRoleAuthorities`, { params: data });
}

export function setRoleAuthorities(data) {
  return axios.post(`${contextPath}/ra/setRoleAuthorities`, data);
}

export function copyRoleAuthorities(data) {
  return axios.postByFormUrl(`${contextPath}/ra/copyRoleAuthorities`, data);
}

// 用户列表
export function userList(data) {
  return axios.get(`${contextPath}/um/users`, { params: data });
}

export function userInsert(data) {
  return axios.post(`${contextPath}/um/createUser`, data);
}

export function userUpdate(data) {
  return axios.post(`${contextPath}/um/updateUser`, data);
}

export function changePassword(data) {
  return axios.postByFormUrl(`${contextPath}/um/changePassword`, data);
}

export function resetPassword(data) {
  return axios.postByFormUrl(`${contextPath}/um/resetPassword`, data);
}

export function changeEnabled(data) {
  return axios.postByFormUrl(`${contextPath}/um/changeUserEnabled`, data);
}

// 组织机构
export function orgList(data) {
  return axios.get(`${contextPath}/org/list`, { params: data });
}

export function orgInsert(data) {
  return axios.postByFormUrl(`${contextPath}/org/add`, data);
}

export function orgDelete(data) {
  return axios.postByFormUrl(`${contextPath}/org/delete`, data);
}

export function orgUpdate(data) {
  return axios.postByFormUrl(`${contextPath}/org/update`, data);
}

export function companyList(data) {
  return axios.get(`${contextPath}/org/companies`, { params: data });
}

// 型号
export function modelList(data) {
  return axios.get(`${contextPath}/mf/models`, { params: data });
}

export function modelInsert(data) {
  return axios.postByFormUrl(`${contextPath}/mf/createModel`, data);
}

export function modelDelete(data) {
  return axios.postByFormUrl(`${contextPath}/mf/deleteModel`, data);
}

export function modelUpdate(data) {
  return axios.postByFormUrl(`${contextPath}/mf/renameModel`, data);
}

// 功能
export function featureList(data) {
  return axios.get(`${contextPath}/mf/feature`, { params: data });
}

export function featureInsert(data) {
  return axios.postByFormUrl(`${contextPath}/mf/createFeature`, data);
}

export function featureDelete(data) {
  return axios.postByFormUrl(`${contextPath}/mf/deleteFeature`, data);
}

export function featureUpdate(data) {
  return axios.postByFormUrl(`${contextPath}/mf/renameFeature`, data);
}

export function getModelFeature(data) {
  return axios.get(`${contextPath}/mf/getModelFeature`, { params: data });
}

export function setModelFeature(data) {
  return axios.post(`${contextPath}/mf/setModelFeature`, data);
}

export function copyModelFeature(data) {
  return axios.postByFormUrl(`${contextPath}/mf/copyModelFeature`, data);
}

// 下载中心
export function exportList(data) {
  return axios.get(`${contextPath}/export/list`, {params: data});
}

export function exportDelete(data) {
  return axios.postByFormUrl(`${contextPath}/export/delete`, data);
}

export function exportDownload(data) {
  window.open(`${contextPath}/export/download?attachment=true&id=${data.id}&token=${data.token}`);
}
